import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone'
import { Controller } from "react-hook-form";
// const DATE_FORMAT = 'ddd MMM D, YYYY';

function FormDatePicker({ getValues, dateFormat, value, control, onChange, type, name, label, sublabel, placeholder, register, defaultName, filePath, error, ...otherProps}) {

    const {fullSize} = otherProps;
    var leftCol = fullSize ? "col-md-3" : "col-md-2"
    var rightCol = fullSize ? "col-md-9" : "col-md-6"

    const invalidStyle = {width: "100%", marginTop: "0.25rem", fontSize: "80%", color: "#ff4136"}

    const dateValue = () => {

        return getValues(name)
        // const timestamp = getValues(name)
        // if (timestamp) {
        //     return moment(timestamp * 1000).format(dateFormat)
        // }
        // return moment().format(dateFormat)
    }

    return (
    <div className="form-group row">
        {label && (<label className={`${leftCol} col-form-label`}>
            <h6>{label}</h6>
            {sublabel && (<small>{sublabel}</small>)}
        </label>)}

        <div className={`${rightCol}`}>
            {/* <DatePicker 
            
            /> */}
            <Controller
                className="form-control w-100"
                as={DatePicker}
                showYearDropdown={true}
                selected={dateValue() ? moment(dateValue(), dateFormat).toDate() : Date()}
                dateFormat={dateFormat}
                // value={dateValue()}
                // as={<DatePicker value={moment(getValues('start_date'), DATE_FORMAT)}/>}
                control={control}
                placeholderText={placeholder}
                onChange={([selected]) => {
                    // setValue('days_of_the_week', [{value:moment(selected).format('dddd'), label:moment(selected).format('dddd')}])
                    // setValue('days_of_the_week', [moment(selected).format('dddd')])
                    // return moment(selected).unix()
                    console.log("Selected date: ", selected)
                    return moment(selected).format(dateFormat)
                }}
                name={name}
            />

            {error && (
                <div style={invalidStyle}>
                    {error.message}
                </div>
            )}
            {/* <div style={{width: "150px", height: "150px", position: "relative"}} className="mr-3">
                
            </div> */}
        </div>

    </div>
    );
}

export default FormDatePicker
